import React, { useState } from "react";
import di from "../di/servicelocator";
import { ESortOrder } from "@domains/utils/sort";
import "../../../../stylesheets/components/Reports/HoldingReports/MobSortDrop.scss";
const MobSortDrop = ({ setSortoptionSelected, setShowSortDrop, sortByFilters, setSortByFilters, }) => {
    const [sortState, setSortState] = useState(sortByFilters);
    const [id, setId] = useState(0);
    const [sortKeyDisplayState, setSortKeyDisplayState] = useState({
        Alphabetical: { asc: "Z to A", desc: "A to Z" },
        "P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "P&L absolute": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "LTP Change %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Day Change": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Investment Value": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Current Value": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
    });
    const clearAllFilter = () => {
        let tempData = sortByFilters;
        tempData = tempData.map((value, id) => {
            value.order = ESortOrder.UNCHANGED;
            return value;
        });
        setSortByFilters === null || setSortByFilters === void 0 ? void 0 : setSortByFilters(tempData);
    };
    const resetSort = () => {
        di.holdingReport.getSortedHoldingReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false);
        setShowSortDrop(false);
    };
    const setSortOrder = (idx, key, value) => {
        setId(idx);
        let tempData = sortState.map((val) => {
            return Object.assign({}, val);
        });
        tempData[idx].order =
            value === ESortOrder.DESC ? ESortOrder.ASC : ESortOrder.DESC;
        tempData = tempData.map((value, id) => {
            if (id !== idx)
                value.order = ESortOrder.UNCHANGED;
            return value;
        });
        setSortState(tempData);
    };
    const sortByFunction = async (idx) => {
        setSortByFilters === null || setSortByFilters === void 0 ? void 0 : setSortByFilters(sortState);
        const sort = sortState[idx];
        di.holdingReport.getSortedHoldingReportData(sort, true);
        setShowSortDrop(false);
    };
    return (React.createElement("div", { className: "mob-sort-drop" },
        React.createElement("div", { className: "mob-sort-drop-head" },
            React.createElement("div", { className: "down-bar container" },
                React.createElement("span", { className: "down-bar-left" }, "Sorting"),
                React.createElement("input", { onClick: resetSort, className: "down-bar-right", type: "button", value: "Reset" }))),
        React.createElement("div", { className: "mob-sort-drop-body" },
            React.createElement("ul", { className: "sort-drop-bodylist" }, sortState.map((val, idx) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("li", { key: "sort-drop-bodylist" + idx, onClick: () => setSortOrder(idx, val.displayName, val.order), style: {
                            color: sortState[idx].order === 0 ? "#444444" : "#3580F7",
                        } },
                        React.createElement("label", null, val.displayName),
                        React.createElement("span", { className: "bodylist-right" },
                            React.createElement("p", { className: "light-right", style: {
                                    color: sortState[idx].order === 0 ? "#B8B8B8" : "#3580F7",
                                } },
                                " ",
                                sortKeyDisplayState[val.displayName][val.order === ESortOrder.ASC ? "asc" : "desc"]),
                            val.order == ESortOrder.ASC ? (React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-point-arrow-up" }))) : (React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-point-arrow-down" }))))),
                    idx == sortByFilters.length - 1 ? null : (React.createElement("div", { className: "border-seperator" }))));
            }))),
        React.createElement("div", { className: "mob-sort-drop-footer" },
            React.createElement("input", { type: "button", value: "Apply Sorting", onClick: () => sortByFunction(id) }))));
};
export default MobSortDrop;
